export const HOMESCREEN_ROUTE = '/home';
